import Avvir, { AssociationIds } from "avvir";
import type { AvvirThunk } from "../../../../make_eventful_action";
import apiFailure, { ApiFailureEvent } from "../../../../../events/notifications/failure_notifications/api_failure";

export const triggerFloorBackup = ({ projectId, floorId }: AssociationIds, backupPurpose: string): AvvirThunk<Promise<void | { id: number }>, ApiFailureEvent> => {
  return (dispatch, getState) => {
    const user = getState().user;

    return Avvir.api.floors.backupFloor({ projectId, floorId }, backupPurpose, user)
      .catch(error => {
        dispatch(apiFailure(error));
      });
  };
};
